
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_o6shp_104",
  "code-editor": "awsui_code-editor_1gl9c_o6shp_104",
  "pane": "awsui_pane_1gl9c_o6shp_674",
  "pane__close-container": "awsui_pane__close-container_1gl9c_o6shp_685",
  "pane__list": "awsui_pane__list_1gl9c_o6shp_690",
  "pane__table": "awsui_pane__table_1gl9c_o6shp_697",
  "pane__item": "awsui_pane__item_1gl9c_o6shp_703",
  "pane__cell": "awsui_pane__cell_1gl9c_o6shp_703",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_o6shp_717",
  "pane__location": "awsui_pane__location_1gl9c_o6shp_738",
  "pane__description": "awsui_pane__description_1gl9c_o6shp_738",
  "focus-lock": "awsui_focus-lock_1gl9c_o6shp_753",
  "editor": "awsui_editor_1gl9c_o6shp_804",
  "editor-refresh": "awsui_editor-refresh_1gl9c_o6shp_832",
  "status-bar": "awsui_status-bar_1gl9c_o6shp_837",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_o6shp_845",
  "status-bar__left": "awsui_status-bar__left_1gl9c_o6shp_849",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_o6shp_856",
  "status-bar__right": "awsui_status-bar__right_1gl9c_o6shp_860",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_o6shp_864",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_o6shp_864",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_o6shp_870",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_o6shp_875",
  "tab-button": "awsui_tab-button_1gl9c_o6shp_881",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_o6shp_913",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_o6shp_916",
  "tab-button--active": "awsui_tab-button--active_1gl9c_o6shp_925",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_o6shp_941",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_o6shp_974",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_o6shp_981",
  "loading-screen": "awsui_loading-screen_1gl9c_o6shp_985",
  "error-screen": "awsui_error-screen_1gl9c_o6shp_986"
};
  